// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"vw_a bhf_b bhf_wb"};